import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { theme } from "../src/theme/theme";
import './App.css';
import { Box, ChakraProvider } from '@chakra-ui/react';
import { Home } from './pages/Home/Home';
import PaymentSuccess from './pages/payment-success/PaymentSuccess';
import { checkTokenValidity } from './utils/checkTokenValidity';
import {useEffect} from "react";



function App() {

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (!token) return;

    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/me`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
        .then(res => res.json())
        .then(data => {
          if (data && data.role) {
            const storedUser = JSON.parse(localStorage.getItem("authUser"));
            if (storedUser.role !== data.role) {
              localStorage.setItem("authUser", JSON.stringify({ ...storedUser, role: data.role }));
              window.location.reload();
            }
          }
        })
        .catch(err => {
          console.error('Failed to update user role', err);
        });
  }, []);

  useEffect(() => {
    checkTokenValidity(); // виклик перевірки при завантаженні
  }, []);

  return (
    <ChakraProvider theme={theme}>
      <Box>
        <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
          </Routes>
        </Router>
      </Box>
    </ChakraProvider>
  );
}

export default App;
